import {db} from "@/firebase/firebaseConfig.js";
import AuthService from "@/services/authService.js";
import TileBelt from "@mapbox/tilebelt";
import moment from "moment-timezone";
import {AiseaApiFactory} from "@/api/aisea/apiFactory";
import {HtmlUtil, ChannelDataUtil} from "@/utils/secure-dataflow";
import firebase from "@firebase/app";

const sdfSeaRoutes = AiseaApiFactory.get("sdfSeaRoutes");
const sdfBatchData = AiseaApiFactory.get("sdfBatchData");
const sdfChannel = AiseaApiFactory.get("enterpriseVesselSecureDataflowChannel");

import _ from "lodash";

export default {
  async subscribeSeaRoute({dispatch, commit, state}, payload) {
    const [unsubscribe1, unsubscribe2] = await Promise.all([
      db
        .collection("vessel_batch_data")
        .doc(`v_${payload.vesselId}`)
        .collection(`o_2`)
        .doc("sea_route")
        .onSnapshot(async doc => {
          if (doc.data()) {
            if (state.initializedSeaRoute) {
              await dispatch("fetchSeaRoute", payload);
            }
          }
        }),

      db
        .collection("vessel_batch_data")
        .doc(`v_${payload.vesselId}`)
        .collection(`o_3`)
        .doc("sea_route")
        .onSnapshot(async doc => {
          if (doc.data()) {
            if (state.initializedSeaRoute) {
              await dispatch("fetchSeaRoute", payload);
            }
          }
        })
    ]);

    await dispatch("fetchSeaRoute", payload);

    commit("SET_INITIALIZED_SEA_ROUTE", true);
    commit("PUSH_UNSUBSCRIBE", unsubscribe1);
    commit("PUSH_UNSUBSCRIBE", unsubscribe2);
  },

  async fetchSeaRoute({commit}, payload) {
    let res = await sdfSeaRoutes.getSeaRoutes(payload.vesselId, {
      request_id: payload.requestId
    });
    if (res.status) {
      let escape = HtmlUtil.htmlEscape(res.data.data.data)
      let seaRoutes = JSON.parse(escape)
      let seaRoutesPoints = seaRoutes.points.map(v => {
        let props = JSON.parse(v.properties);
        v["properties"] = props;
        return v;
      });
      commit("SET_SEA_ROUTES", seaRoutesPoints);
      commit("SET_ARRIVAL_POINT", seaRoutesPoints.slice(-1)[0]);
    } else {
      commit("SET_SEA_ROUTES", []);
    }
  },

  async subscribeEvent({commit, state}, payload) {
    let unsubscribe = await db
      .collection("vessel_batch_data")
      .doc(`v_${payload.vesselId}`)
      .collection(`o_${payload.originId}`)
      .doc("event")
      .onSnapshot(async doc => {
        if (doc.data()) {
          let res = await sdfBatchData.getBatchData(payload.vesselId, {
            kind: "event",
            origin: payload.originId,
            request_id: payload.requestId
          });
          let escape = HtmlUtil.htmlEscape(res.data.data.data)
          let eventData = JSON.parse(escape)
          commit("SET_EVENT_DATA", eventData);
          let veeringPoints = eventData.veering_points_info;
          // 通過中の場所を特定
          let latestDeparturePoint = null;
          let nextArrivalPoint = null;
          let passingPoints = [];
          const veeringPointsCopy = _.cloneDeep(veeringPoints);
          veeringPointsCopy.sort((a, b) => {
            if (a.number_of_point > b.number_of_point) return 1;
            if (a.number_of_point < b.number_of_point) return -1;
            return 0;
          });

          let cnt = 0
          veeringPointsCopy.some(value => {
            if (typeof value.actual_time === "undefined" || value.actual_time === "" || value.actual_time === null) {
              latestDeparturePoint = veeringPointsCopy[value.number_of_point - 1]
              return true;
            }
            cnt = cnt + 1
          });

          if(cnt === veeringPointsCopy.length) {
            latestDeparturePoint = veeringPointsCopy.slice(-1)[0]
          }

          // 最終出発地が無い場合は初期位置を最終出発地とする
          if (!latestDeparturePoint) {
            latestDeparturePoint = veeringPointsCopy[0]
          }

          commit("SET_LATEST_DEPARTURE_POINT", latestDeparturePoint);

          for (let step = 1; step <= latestDeparturePoint.number_of_point; step++) {
            passingPoints.push(step)
          }

          // 目的地に到着したかどうかを判定
          if (latestDeparturePoint.number_of_point === state.seaRoutes.length - 1) {
            commit("SET_NEXT_ARRIVAL_POINT", latestDeparturePoint);
            commit("SET_IS_ARRIVED_POINT", true);
          } else {
            let nextPoint = latestDeparturePoint.number_of_point + 1
            nextArrivalPoint = veeringPoints[nextPoint]
            // veeringPointsにない場合seaRoutesから作る
            if (!nextArrivalPoint) {
              nextArrivalPoint = {
                "actual_time": null,
                "latitude": state.seaRoutes[nextPoint].latitude,
                "longitude": state.seaRoutes[nextPoint].longitude,
                "number_of_point": nextPoint,
                "target_time": null
              }
            }
            commit("SET_NEXT_ARRIVAL_POINT", nextArrivalPoint);
          }

          // 着岸モード開始かどうかを判定 (到着航路の３つ手前から) ＊着岸モードはSBXのモード判定するため現状使ってない
          if (latestDeparturePoint.number_of_point === state.seaRoutes.length - 2) {
            commit("SET_BERTH_MODE", true);
          }

          commit("SET_VEERING_POINTS", veeringPoints);
          commit("SET_PASSING_POINTS", passingPoints);
        }
      });

    commit("PUSH_UNSUBSCRIBE", unsubscribe);
  },

  async subscribeChannelDataManeuvering({dispatch, commit, state}, payload) {
    let unsubscribe = await db
      .collection("vessel_channel_data")
      .doc(`v_${payload.vesselId}`)
      .collection("handling")
      .doc(payload.versionName)
      .collection("data")
      .onSnapshot(handlingCollectionRef => {
        if (typeof handlingCollectionRef.docs !== "undefined" && !state.isPositionsUpdatingByApi) {
          dispatch("crateManeuveringData", handlingCollectionRef.docs)
        }
      });
    commit("PUSH_UNSUBSCRIBE", unsubscribe);
  },

  crateManeuveringData: _.debounce(function ({commit, state}, docs) {
    let maneuveringDataDic = {}
    docs.forEach(v => {
      let maneuveringData = v.data()
      if (maneuveringData.ch) {
        maneuveringDataDic[maneuveringData.ch] = maneuveringData
      } else {
        // 初回のfirebaseの更新時間取得のときのみ
        if (state.maneuveringDataFirstFetchFromFirebase) {
          // firestoreからデータのtimestampが3分以上過去だった場合、timestampを最終更新時刻として更新（初回取得は機関、操船、それぞれ分けて考える）
          // firestoreからデータのtimestampが過去3分未満だった場合、データを取得できた瞬間にブラウザタイムを最終更新時刻として更新
          const isLatestData = moment().diff(moment(maneuveringData.timestamp.toDate()), "minutes") < 3;
          maneuveringDataDic["last_updated_at"] = isLatestData ? firebase.firestore.Timestamp.now() : maneuveringData.timestamp
          commit("SET_MANEUVERING_DATA_FIRST_FETCH_FROM_FIREBASE", false)
        } else {
          // 初回取得以降、firestoreからデータを取得できた瞬間にブラウザタイムを最終更新時刻として更新
          maneuveringDataDic["last_updated_at"] =  firebase.firestore.Timestamp.now()
        }
      }
      // 対地速力（高精度GPS）
      if(maneuveringData.ch === "SB05"){
        if(maneuveringData.vn < 1) {
          commit("SET_IS_LESS_THAN_1KN", true);
        }else{
          commit("SET_IS_LESS_THAN_1KN", false);
        }
      }
    })
    commit("SET_CHANNEL_DATA_MANEUVERING", maneuveringDataDic);
  }, 1000),

  async subscribeChannelDataEngine({dispatch, commit}, payload) {
    let unsubscribe = await db
      .collection("vessel_channel_data")
      .doc(`v_${payload.vesselId}`)
      .collection("engine")
      .doc(payload.versionName)
      .collection("data")
      .onSnapshot(engineCollectionRef => {
        if (typeof engineCollectionRef.docs !== "undefined") {
          dispatch("crateEngineData", {
            docs: engineCollectionRef.docs,
            vesselId: payload.vesselId,
            versionName: payload.versionName
          })
        }
      })
    commit("PUSH_UNSUBSCRIBE", unsubscribe);

  },

  crateEngineData: _.debounce(function ({dispatch, commit, state}, payload) {
    let engineDataDic = {}
    payload.docs.forEach(v => {
      let engineData = v.data()
      if (engineData.ch) {
        engineDataDic[engineData.ch] = engineData
      } else {
        // 初回のfirebaseの更新時間取得のときのみ
        if (state.engineDataFirstFetchFromFirebase) {
          // firestoreからデータのtimestampが3分以上過去だった場合、timestampを最終更新時刻として更新（初回取得は機関、操船、それぞれ分けて考える）
          // firestoreからデータのtimestampが過去3分未満だった場合、データを取得できた瞬間にブラウザタイムを最終更新時刻として更新
          const isLatestData = moment().diff(moment(engineData.timestamp.toDate()), "minutes") < 3;
          engineDataDic["last_updated_at"] = isLatestData ? firebase.firestore.Timestamp.now() : engineData.timestamp
          commit("SET_ENGINE_DATA_FIRST_FETCH_FROM_FIREBASE", false)
        } else {
          // 初回取得以降、firestoreからデータを取得できた瞬間にブラウザタイムを最終更新時刻として更新
          engineDataDic["last_updated_at"] =  firebase.firestore.Timestamp.now()
        }
      }
    })
    commit("SET_CHANNEL_DATA_ENGINE", engineDataDic);
    dispatch("calcFOFlow", {
      vesselId: payload.vesselId,
      versionName: payload.versionName,
      FOChannels: ["2511", "2513", "2512", "2514"]
    });
  }, 1000),

  async getInitialFOFlow({commit}, payload) {
    let initialFOFlowData = await db
      .collection("vessel_channel_data")
      .doc(`v_${payload.vesselId}`)
      .collection("engine")
      .doc(payload.versionName)
      .collection("data")
      .where("ch", 'in', ['2511', '2512', '2513', '2514'])
      .get()
      .then((querySnapshot) => {
        let data = {}
        querySnapshot.forEach((doc) => {
          data[doc.data().ch] = doc.data()
        });
        return data
      })
    commit("SET_INITIAL_FO_FLOW_DATA", initialFOFlowData);
  },

  async setInitialFOFlow({commit}, payload) {
    let from = moment().utc().subtract(90, "s")
    let to = moment().utc()
    let params = {
      vessel_id: payload.vesselId,
      body: {
        channel_ids: ['2511', '2512', '2513', '2514'],
        origin: payload.originId,
        kind: payload.kind,
        version_id: payload.versionId,
        channel_time_from: from.toISOString(),
        channel_time_to: to.toISOString(),
      }
    };
    let res = await sdfChannel.searchChannelsData(params.vessel_id, params.body)
    if (res.status && res.data.data.length !== 0) {
      let initialFOFlowData = {}
      res.data.data.forEach(v => {
        initialFOFlowData[v.channel_id] = {
          ch: v.channel_id,
          properties: v.channel_data[0].properties,
          status: v.channel_data[0].status,
          timestamp: moment(v.channel_data[0].channel_time).utc().valueOf(),
          vn: v.channel_data[0].value_number,
          vs: null,
        }
      })
      commit("SET_INITIAL_FO_FLOW_DATA", initialFOFlowData);
    }
  },

  async subscribeChannelDataAlert({commit}, payload) {
    let unsubscribe = await db
      .collection("vessel_channel_data")
      .doc(`v_${payload.vesselId}`)
      .collection("aisea_alert")
      .doc(payload.versionName)
      .collection("data")
      .onSnapshot(aiseaAlertCollectionRef => {
        let alerts = {}
        aiseaAlertCollectionRef.docs.forEach(v => {
          alerts[v.data().ch] = v.data()
        })
        commit("SET_CHANNEL_DATA_ALERT", alerts);
      });
    commit("PUSH_UNSUBSCRIBE", unsubscribe);
  },

  async fetchOtherVesselsPosition({dispatch}, payload) {
    let qkList = [];
    let zoom = 10;
    let centerTile = TileBelt.pointToTile(
      payload.coordinates.longitude,
      payload.coordinates.latitude,
      zoom
    );

    let topTileX = centerTile[0];
    let topTileY = centerTile[1] - 1;
    let topTile = [topTileX, topTileY, zoom];
    let topRightTileX = centerTile[0] + 1;
    let topRightTileY = centerTile[1] - 1;
    let topRightTile = [topRightTileX, topRightTileY, zoom];
    let topLeftTileX = centerTile[0] - 1;
    let topLeftTileY = centerTile[1] - 1;
    let topLeftTile = [topLeftTileX, topLeftTileY, zoom];
    let bottomTileX = centerTile[0];
    let bottomTileY = centerTile[1] + 1;
    let bottomTile = [bottomTileX, bottomTileY, zoom];
    let bottomRightTileX = centerTile[0] + 1;
    let bottomRightTileY = centerTile[1] + 1;
    let bottomRightTile = [bottomRightTileX, bottomRightTileY, zoom];
    let bottomLeftTileX = centerTile[0] - 1;
    let bottomLeftTileY = centerTile[1] + 1;
    let bottomLeftTile = [bottomLeftTileX, bottomLeftTileY, zoom];
    let leftTileX = centerTile[0] - 1;
    let leftTileY = centerTile[1];
    let leftTile = [leftTileX, leftTileY, zoom];
    let rightTileX = centerTile[0] + 1;
    let rightTileY = centerTile[1];
    let rightTile = [rightTileX, rightTileY, zoom];

    let centerQk = TileBelt.tileToQuadkey(centerTile);
    qkList.push(centerQk);

    let topTileQk = TileBelt.tileToQuadkey(topTile);
    qkList.push(topTileQk);

    let topLeftQk = TileBelt.tileToQuadkey(topLeftTile);
    qkList.push(topLeftQk);

    let topRightQk = TileBelt.tileToQuadkey(topRightTile);
    qkList.push(topRightQk);

    let bottomTileQk = TileBelt.tileToQuadkey(bottomTile);
    qkList.push(bottomTileQk);

    let bottomRightQk = TileBelt.tileToQuadkey(bottomRightTile);
    qkList.push(bottomRightQk);

    let bottomLeftQk = TileBelt.tileToQuadkey(bottomLeftTile);
    qkList.push(bottomLeftQk);

    let qkLeft = TileBelt.tileToQuadkey(leftTile);
    qkList.push(qkLeft);

    let qkRight = TileBelt.tileToQuadkey(rightTile);

    qkList.push(qkRight);

    let minAgo = moment()
      .utc()
      .subtract(10, "minutes")
      .valueOf();

    const collectionName = await AuthService.getVesselPositionCollectionName();
    db
      .collection(collectionName)
      .where("t", ">", minAgo)
      .get()
      .then(querySnapshot => {
        let pos = [];
        querySnapshot.forEach(docPosition => {
          if (docPosition.data().qk) {
            for (const qk of qkList) {
              if (docPosition.data().qk.startsWith(qk)) {
                if (payload.myVesselId === docPosition.id) continue; // 自船は除外
                db.collection("vessel_info").doc(docPosition.id)
                  .get()
                  .then((doc) => {
                    let vesselInfo = doc.data()
                    if (typeof vesselInfo !== "undefined" && typeof docPosition.data() !== "undefined") {
                      pos.push({
                        vesselId: docPosition.id,
                        info: vesselInfo,
                        position: docPosition.data()
                      });
                      dispatch("addOtherVessels", pos)
                    }
                  });
              }
            }
          }
        });
        return pos;
      });
  },

  addOtherVessels: _.debounce(function ({commit}, payload) {
    commit("SET_OTHER_VESSELS_POSITION", payload);
  }, 1500),


  async calcFOFlow({commit, state}, payload) {
    if (state.initialFOFlowData === null) {
      commit("SET_FO_FLOWS_SUM", null);
      return
    }

    let starboardFOFlow1 = 0
    let portFOFlow1 = 0
    let starboardFOFlow2 = 0
    let portFOFlow2 = 0

    let timeDiff
    payload.FOChannels.forEach(ch => {
      if (typeof state.initialFOFlowData[ch] !== "undefined") {
        let dateFrom = moment(state.initialFOFlowData[ch].timestamp)
        let dateTo = moment(state.channelDataEngine[ch].timestamp)
        timeDiff = dateTo.diff(dateFrom, 's')
        if (timeDiff >= 60) {
          let useFuel = state.channelDataEngine[ch].vn - state.initialFOFlowData[ch].vn
          let result = (useFuel / timeDiff) * 3600;
          if (ch === "2511") {
            starboardFOFlow1 = result
          } else if (ch === "2513") {
            portFOFlow1 = result
          } else if (ch === "2512") {
            starboardFOFlow2 = result
          } else {
            portFOFlow2 = result
          }
        }
      }
    })

    if (timeDiff >= 60) {
      commit("SET_FO_FLOWS", {
        starboardFOFlow1: starboardFOFlow1,
        portFOFlow1: portFOFlow1,
        starboardFOFlow2: starboardFOFlow2,
        portFOFlow2: portFOFlow2
      });

      let sum = starboardFOFlow1 + portFOFlow1 + starboardFOFlow1 + portFOFlow2
      commit("SET_FO_FLOWS_SUM", sum);

      let copy = _.cloneDeep(state.channelDataEngine)
      let initialFOFlowData = {
        2511: copy[2511],
        2512: copy[2512],
        2513: copy[2513],
        2514: copy[2514]
      }
      commit("SET_INITIAL_FO_FLOW_DATA", initialFOFlowData);
    }

  },

  async setTrackHistoryPositions({commit}, payload) {
    let endTime = moment.utc().subtract(3, "m").toISOString();
    let startTime = moment(endTime).subtract(payload.trackHistoryInterval, "m").toISOString();
    let prams = {
      started_at: startTime,
      ended_at: endTime,
    }
    let res = await AiseaApiFactory.get("enterpriseVoyageHistoryPoint").fetch(payload.vesselId, prams)
    let historyPoints = res.data.points
    if (historyPoints.length === 0) return
    let trackHistories = []
    // 時間の重複データ削除
    let filterHistoryPoints = historyPoints.filter((v1, i1, a1) => {
      return (
        a1.findIndex(v2 => {
          return v1.t === v2.t;
        }) === i1
      );
    });
    // ソート
    filterHistoryPoints.sort((a, b) => {
      return moment(a.t).utc().valueOf() > moment(b.t).utc().valueOf() ? 1 : -1;
    });
    filterHistoryPoints.forEach(v => {
      let trackHistory = {
        datetime: moment.utc(v.t).valueOf(),
        distanceFromBowToBerth: null,
        distanceFromSternToBerth: null,
        latitude: v.lat,
        longitude: v.lon,
        maneuveringMode: null,
        operationMode: null,
        speedOverGroundPrecise: null,
        steeringMode: null,
        vesselHeading: null
      }
      trackHistories.push(trackHistory)
    })

    commit("SET_TRACK_HISTORIES", trackHistories);

  },

  async checkChannelDataManeuveringLastUpdate({state, commit}) {
    if (state.channelDataManeuvering === null) return
    let dateTo = moment().utc()
    let copy = _.cloneDeep(state.channelDataManeuvering)
    let copyObj = Object.values(copy)
    let dateFrom = moment(copyObj[0].timestamp).utc()
    if (dateFrom.diff(dateTo, 'm') <= -3) {
      let channelDataManeuvering = {}
      copyObj.forEach(v => {
        if (v.ch !== null) {
          if (v.ch !== "SB02" && v.ch !== "SB03" && v.ch !== "SB07" && v.ch !== "SB08") {
            v.vn = null
            v.vs = null
          }
          channelDataManeuvering[v.ch] = v
        } else {
          channelDataManeuvering["last_updated_at"] = v.timestamp
        }
      })
      commit("SET_CHANNEL_DATA_MANEUVERING", channelDataManeuvering);
    }
  },

  async checkChannelDataEngineLastUpdate({state, commit}) {
    if (state.channelDataEngine === null) return
    let dateTo = moment().utc()
    let copy = _.cloneDeep(state.channelDataEngine)
    let copyObj = Object.values(copy)
    let dateFrom = moment(copyObj[0].timestamp).utc()
    if (dateFrom.diff(dateTo, 'm') <= -3) {
      let channelDataEngine = {}
      copyObj.forEach(v => {
        if (v.ch !== null) {
          v.vn = null
          v.vs = null
          channelDataEngine[v.ch] = v
        } else {
          channelDataEngine["last_updated_at"] = v.timestamp
        }
      })
      commit("SET_CHANNEL_DATA_ENGINE", channelDataEngine);
    }
  },

  async updateGhostPoistions({ state, commit, getters }, responseData) {
    const flatten = responseData.reduce((prev, data) => {
      const d = data.channel_data;
      const nextD = [...prev, ...d];
      return nextD;
    }, []);

    const jumpingTimestamp =
      state.ghostPositions[getters.junmpingGhostPosition].datetime;
    const channelDataDict = flatten.reduce((prev, p) => {
      const {
        properties: properties,
        channel_id: ch,
        status: status,
        value_number: vn,
        value_string: vs,
        // origin_time: originTime,
        channel_time: channelTime
      } = p;

      const timestamp = moment(channelTime).valueOf();
      // 取得データがゴーストが飛び始めた時と同じデータを持っている場合があるのでフィルタする
      const isDuplicate = timestamp === jumpingTimestamp;
      if (isDuplicate) return prev;

      const addTarget = prev[timestamp] || {};
      const n = {
        ...prev,
        [timestamp]: {
          ...addTarget,
          [ch]: { properties, ch, status, vn, vs, timestamp }
        }
      };
      return n;
    }, {});

    // const channelDataValues = Object.values(channelDataDict).sort;
    const channelDataValues = Object.keys(channelDataDict)
      .sort((a, b) => a - b)
      .map(key => channelDataDict[key]);
      // NOTE: 最も新しいチャンネルデータは、下の方で別に更新する
    const latestChannelDataValues = channelDataValues[channelDataValues.length - 1];
    const maneuveringTrackPositions = channelDataValues
      .slice(0, channelDataValues.length - 1)
      .map(value => ChannelDataUtil.getVesselInfoByChannelData(value));

    let oldestTimestamp = jumpingTimestamp;
    const filteredPostisons = maneuveringTrackPositions.filter(p => {
      let dateTo = moment(p.datetime);
      let dateFrom = moment(oldestTimestamp);
      let diff = dateTo.diff(dateFrom, "m");

      const isGhost = diff >= 1;
      if (isGhost) {
        oldestTimestamp = p.datetime;
      }
      return isGhost;
    });
    const oldGhostPostions = state.ghostPositions.slice(
      0,
      getters.junmpingGhostPosition + 1
    );
    const oldTrackPostions = state.trackPositions.slice(
      0,
      getters.jumpingTrackPosition + 1
    );
    const nextGhostPositions = [...oldGhostPostions, ...filteredPostisons];
    const nextTrackPositions = [...oldTrackPostions, ...maneuveringTrackPositions];
    commit("SET_GHOST_POSITIONS", nextGhostPositions);
    commit("SET_TRACK_POSITIONS", nextTrackPositions);

    // NOTE: 最も新しい取得データでchannel_dataを更新
    if (channelDataValues.length > 0) {
      const currentManeuveringData = state.channelDataManeuvering;
      // NOTE: last_updated_atはAPI取得データの最新のchannel_timeで更新する
      const latestUpdatedAtMiliseconds = Object.values(
        latestChannelDataValues
      ).find(v => v && v.timestamp)["timestamp"];

      const lastUpdatedAt =
        latestUpdatedAtMiliseconds
          ? firebase.firestore.Timestamp.fromMillis(latestUpdatedAtMiliseconds)
          : (currentManeuveringData && currentManeuveringData.last_updated_at);
      const nextManeuveringData = {
        ...latestChannelDataValues,
        "last_updated_at": lastUpdatedAt
      };
      if (nextManeuveringData.SB05.vn) {
        if (nextManeuveringData.SB05.vn < 1) {
          commit("SET_IS_LESS_THAN_1KN", true);
        } else {
          commit("SET_IS_LESS_THAN_1KN", false);
        }
      }
      commit("SET_CHANNEL_DATA_MANEUVERING", nextManeuveringData);
    }
  },

  async unsubscribeFirestore({commit}) {
    commit("UNSUBSCRIBE_FIRE_STORE");
  },

  async resetStateOfMonitoringVesselManeuvering({commit}) {
    let defaultState = {
      channelDataManeuvering: null,
      channelDataEngine: null,
      channelDataAlert: null,
      abnormalMachinery: [],
      initializedSeaRoute: false,
      seaRoutes: null,
      veeringPoints: null,
      passingPoints: null,
      isArrivedPoint: false,
      isLessThan1kn: false,
      eventData: null,
      isBerthMode: false,
      arrivalPoint: null,
      latestDeparturePoint: null,
      nextArrivalPoint: null,
      otherVesselsPosition: [],
      otherVesselsInfo: null,
      trackPositions: [],
      trackHistories: null,
      ghostPositions: [],
      vesselInfo: null,
      jumpTo: null,
      connectingState4gVSAT: null,
      connectingStateSBX: null,
      connectingStateAMS: null,
      initialFOFlowData: null,
      foFlows: {
        starboardFOFlow1: -1,
        portFOFlow1: -1,
        starboardFOFlow2: -1,
        portFOFlow2: -1
      },
      foFlowsSum: -1,
      estimateFOFlow: [],
      unsubscribes: [],
      // 仮想岸壁
      virtualQuayPositions: [
        [
          [139.6794285, 35.2845477],
          [139.6780015, 35.2808077]
        ],
        [
          [130.9934759, 33.8777636],
          [130.9935619, 33.8751696]
        ]
      ],
      isPositionsUpdatingByApi: false,
      beforeUpdatingGhostByApiDatetime: null,
      engineDataFirstFetchFromFirebase: true,
      maneuveringDataFirstFetchFromFirebase: true,
    };
    commit("RESET_STATE", defaultState);
  }
};
